import { memo } from 'react';


export const VideoBackground = memo(function VideoBackground({ src }: { src: string }) {
    return <div style={{ position: 'sticky', left: '0', top: '0', width: '0', height: '0', overflow: 'visible' }}>
        <video style={{ position: 'absolute', top: '0', width: '100vw', height: '100vh', objectFit: 'cover', objectPosition: 'top right' }} src={src} loop autoPlay muted />
    </div>
})
